import { Grid, Stack, Typography, useTheme } from '@mui/material';
import { Title } from 'components/AddCareCenter';

import {
  Section,
  KidneyFunctionOverTimeChart,
  QualityOfLifeScoresOverTimeChart,
  FamilyMembersWithADPKD,
  FamilyHistoryOfAneurysms,
  OtherComorbidities,
  DietConsiderations,
  YourCareTeam,
  BloodPressureControl,
} from 'components/CareSummary';

import { ReactComponent as PrinterIcon } from 'images/Consent/printer.svg';
import { PrintButtonWrapper } from 'pages/Consent/styles';
import DefaultWrapper from 'shared-components/DefaultWrapper';

const CareSummary = () => {
  const theme = useTheme();
  return (
    <DefaultWrapper
      crumbs={[{ title: 'Care Summary', isActive: true }]}
      showHeader={true}
      margin={{ xs: '10px 0px 0px 0px', lg: '10px 78px 0px 78px' }}>
      <Stack
        sx={{
          padding  : { xs: '15px', sm: '10px 15px 10px 15px' },
          maxWidth : '1380px',
          marginX  : 'auto',
        }}>
        <PrintButtonWrapper
          text='Print'
          color={theme.palette.primary.gray6}
          borderColor={theme.palette.primary.gray3}
          startIcon={<PrinterIcon />}
          width='98px'
          onClickHandler={() => window.print()}
        />
        <Title>Care Summary</Title>
        <Typography
          variant='pl1'
          mb={6}
          mt={0}
          color='primary.grey6'
          component='p'>
          Bring this with you when you visit your doctor
        </Typography>
        <Grid
          container spacing={6} mb={6}>
          <Grid
            item xs={12} md={6} sx={{ display: 'flex' }}>
            <KidneyFunctionOverTimeChart />
          </Grid>
          <Grid
            item xs={12} md={6} sx={{ display: 'flex' }}>
            <QualityOfLifeScoresOverTimeChart />
          </Grid>
        </Grid>
        <Section>Family history</Section>
        <Grid
          container spacing={6} mb={6}>
          <Grid
            item xs={12} md={6} sx={{ display: 'flex' }}>
            <FamilyMembersWithADPKD />
          </Grid>
          <Grid
            item xs={12} md={6} sx={{ display: 'flex' }}>
            <FamilyHistoryOfAneurysms />
          </Grid>
        </Grid>
        <Section>More info</Section>
        <Grid
          container spacing={6} mb={6}>
          <Grid
            item xs={12} md={6} sx={{ display: 'flex' }}>
            <OtherComorbidities />
          </Grid>
          <Grid
            item xs={12} md={6} sx={{ display: 'flex' }}>
            <DietConsiderations />
          </Grid>
        </Grid>
        <Section>From your medical records</Section>
        <Grid
          container spacing={6}>
          <Grid
            item xs={12} md={6} sx={{ display: 'flex' }}>
            <YourCareTeam />
          </Grid>
          <Grid
            item xs={12} md={6} sx={{ display: 'flex' }}>
            <BloodPressureControl />
          </Grid>
          {/* <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
            <TotalKidneyVolume />
          </Grid> */}
        </Grid>
      </Stack>
    </DefaultWrapper>
  );
};

export default CareSummary;
